import Env from '../base/env';

export default () => ({
  hideStockAlert() {
    Env.$html.classList.remove('stock-alert-opened');
  },
  showStockAlert() {
    Env.$html.classList.add('stock-alert-opened');
  },
  cardItemBase(item) {
    console.log('card item base');
  },
});
